'use client';

import type { BulletListColumns, BulletListResolved } from './types';
import { Icon } from '@/components/Icon';
import { Text } from '@/lib/render/Text';

export const DEFAULT_BULLET_LIST_COLUMNS: BulletListColumns = '4';

// One column on mobile; the editor's count from `md` up. Items fill the grid
// row by row, like the Our Close Locations link list (10.03.02.01.14 § AC 4).
// Also like it (`LinkList`), the one-column list shrinks to its widest entry
// and centres on mobile, so the checkmarks stay aligned with each other.
const COLUMNS: Record<BulletListColumns, string> = {
  '1': '',
  '2': 'md:grid-cols-2',
  '3': 'md:grid-cols-3',
  '4': 'md:grid-cols-4',
};

/**
 * Plain text entries with the rich-text checkmark bullet (`.checkmark-list` in
 * globals.css), e.g. the subjects on the City-Jobs Page (10.03.03.33). No
 * title field: editors place a Title Widget before it.
 */
export function BulletListComponent({
  resolved,
}: {
  resolved: BulletListResolved;
}) {
  const items = resolved.items ?? [];
  if (items.length === 0) {
    return null;
  }

  return (
    <div className="pt-4">
      <ul
        className={`checkmark-list mx-auto grid w-fit list-none grid-cols-1 gap-x-4 gap-y-2 pl-0 md:w-full ${COLUMNS[resolved.columns] ?? ''}`}
      >
        {items.map((item) =>
          item.icon ? (
            // An entry's own icon replaces the checkmark (`.has-icon` opts out
            // of the `.checkmark-list` bullet), tinted primary like the
            // legacy page's blue icons.
            <li
              key={item.key}
              className="has-icon my-0 flex items-center gap-4"
            >
              <Icon
                src={item.icon}
                size={48}
                className="text-primary shrink-0"
              />
              <Text>{item.text}</Text>
            </li>
          ) : (
            <li key={item.key} className="my-0">
              <Text>{item.text}</Text>
            </li>
          ),
        )}
      </ul>
    </div>
  );
}
